import PropTypes from "prop-types";

export const CoordinatesType = PropTypes.arrayOf(PropTypes.number);

export const PolygonType = PropTypes.arrayOf(CoordinatesType);

export const MultiPolygonType = PropTypes.arrayOf(PolygonType);

export const HexType = PropTypes.shape({
  polygon: PolygonType.isRequired,
  h3Index: PropTypes.string.isRequired,
});

export const ZoneType = PropTypes.shape({
  polygon: PropTypes.oneOfType([PropTypes.arrayOf(MultiPolygonType), MultiPolygonType]),
  hexes: PropTypes.objectOf(HexType),
});

export const LayerType = PropTypes.shape({
  zones: PropTypes.objectOf(ZoneType),
});

export const RefType = PropTypes.shape({
  current: PropTypes.object,
});
